import { fetchTrip } from "v2/api/trip";
import {
  getArrivalAirport,
  getDepartureAirport,
  updateFlightDetails,
  updateItineraryFlights,
  updateClaimDetails,
} from "../state/preEligibilityState";
import { setChMobileCookie } from "v2/utils/chMobileSessionCookie";

export async function loadAirportsFromItineraryId(itineraryId: string) {
  const response = await fetchTrip(itineraryId);
  if (!response || !response.flights.length)
    return {
      departureAirport: undefined,
      arrivalAirport: undefined,
      hasConnections: false,
    };
  setChMobileCookie();
  updateClaimDetails({
    channel: "ch_mobile",
    itineraryId: itineraryId,
  });

  updateItineraryFlights(
    response.flights.map((flight) => {
      const departureAirport = flight?.departure_airport;
      const arrivalAirport = flight?.arrival_airport;
      const airline = flight?.airline;
      return {
        departureAirport: {
          iata: departureAirport.code.iata,
          name: departureAirport.name,
          city: departureAirport.city.display_name,
        },
        arrivalAirport: {
          iata: arrivalAirport.code.iata,
          name: arrivalAirport.name,
          city: arrivalAirport.city.display_name,
        },
        airline: {
          iata: airline.code.iata,
          name: airline.name,
          uniqueIdentifier: airline.identifier,
        },
        flightNumber: flight?.number,
        flightDate: new Date(flight?.local_departure_date),
        disrupted: flight?.identifier === response?.disruption_info?.disrupted_flight_identifier,
      };
    }),
  );

  updateFlightDetails({
    anyConnections: response.flights.length > 1,
    connections: response.flights.slice(1).map((flight) => ({
      airport: {
        iata: flight.departure_airport.code.iata,
        name: flight.departure_airport.name,
        city: flight.departure_airport.city.display_name,
      },
    })),
  });

  return {
    departureAirport: getDepartureAirport(),
    arrivalAirport: getArrivalAirport(),
    hasConnections: response.flights.length > 1,
  };
}
